module.exports = __webpack_public_path__ + "static/banner-gruppo-pam-45c989e0cacdce7334a35d7240ff1ca1.jpg";